export default "__VITE_ASSET__dc7a038c__"